export const UploadImage = ()=>{
    return <>
        <div>Nahrání obrázku na server</div>
        <input type={'file'}/>
    </>

}